import { Tabs } from '@fiado/react-kit';
import { PlatformTenantRolesTable } from './PlatformTenantRolesTable';
import { PlatformTenantPermissionMatrix } from './PlatformTenantPermissionMatrix';

export type PlatformTenantRolesTab = 'roles' | 'matrix';

const TABS: { key: PlatformTenantRolesTab; label: string }[] = [
    { key: 'roles', label: 'Roles' },
    { key: 'matrix', label: 'Matriz de permisos' },
];

interface Props {
    tenantId: string;
    tab?: PlatformTenantRolesTab;
    onTabChange: (tab: PlatformTenantRolesTab) => void;
}

/** Pestañas «Roles | Matriz de permisos» del tenant visto desde plataforma; la activa vive en la URL. */
export function PlatformTenantRolesTabs({ tenantId, tab = 'roles', onTabChange }: Props) {
    return (
        <div className="space-y-4">
            <Tabs
                tabs={TABS}
                activeTab={tab}
                onChange={(k) => {
                    onTabChange(k as PlatformTenantRolesTab);
                }}
            />
            {tab === 'matrix' ? (
                <PlatformTenantPermissionMatrix tenantId={tenantId} />
            ) : (
                <PlatformTenantRolesTable tenantId={tenantId} />
            )}
        </div>
    );
}
